/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 19:22:22
 * @LastEditors: lwq
 * @LastEditTime: 2020-08-11 17:51:12
 * @FilePath: \mrc-base-server-view\src\service\api\dataView.js
 */
// 视图管理接口
import http from '../httpConfig'
const table = 'mrbase_sys_datamodel_table'


// 运行视图管理语句
export const runSql = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/view/runSql/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 新增和修改视图管理
export const addUpdateViewInfo = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/view/saveViewInfo/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


// 删除视图管理 
export const deleteTable = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/view/deleteTable/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取视图管理信息 
export const getViewTableInfo = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/view/getViewTableInfo/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取所有视图管理信息 
export const getViewTableAll = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/view/getViewTableAll/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}